function getCsrfToken() {
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ?? ""
  );
}

const DEFAULT_HEADERS = {
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

export default async function apiFetch(path, options = {}) {
  const { schoolSlug, schoolYearId, headers, body, ...rest } = options;

  const mergedHeaders = {
    ...DEFAULT_HEADERS,
    ...(schoolSlug ? { "X-School-Slug": schoolSlug } : {}),
    ...(schoolYearId ? { "X-School-Year-ID": schoolYearId } : {}),
    // FormData bodies must let the browser set the multipart boundary header.
    ...(body && !(body instanceof FormData)
      ? { "Content-Type": "application/json" }
      : {}),
    "X-CSRF-Token": getCsrfToken(),
    ...headers,
  };

  const response = await fetch(path, {
    ...rest,
    ...(body ? { body } : {}),
    headers: mergedHeaders,
  });

  if (response.status === 401) {
    const fallback = `/login?redirect=${encodeURIComponent(
      window.location.pathname + window.location.search
    )}`;
    const payload = await response
      .clone()
      .json()
      .catch(() => ({}));
    window.location.assign(payload?.redirect_to || fallback);
    return new Promise(() => {
      // remove JWT token from local storage to force a new login
      window.localStorage.removeItem("tk");
    });
  }

  return response;
}
